import {Component, ElementRef, NgZone, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';

import {filter, Subscription} from 'rxjs';

import {TranslateService} from '@ngx-translate/core';

import {MapService} from '@commons/services/map/map/map.service';
import {PanelNavigationService} from '@commons/services/navigation/panel-navigation.service';
import {VehicleService} from '@commons/services/vehicle/vehicle.service';
import {Vehicle} from '../../../commons/models/domain/Vehicle';
import {VehicleControlIndicator} from '../../../commons/models/domain/VehicleControlIndicator';
import {ConfigurationService} from '@commons/services/configuration/configuration.service';
import {Config} from '../../../commons/models/domain/Config';
import {FullAddressPipe} from '@commons/pipes/full-address.pipe';
import {DriverFullNamePipe} from '@commons/pipes/driver-full-name.pipe';
import {MapControlService} from '@commons/services/map/control/map-control.serivce';
import {MapConfigService} from '@commons/services/map/config/map-config.service';

import {TranslateHelperService} from "@shared/services/translate-helper.service";

@Component({
    selector: 'tk-vehicle-list-full',
    templateUrl: './vehicle-list-full.component.html',
    styleUrls: ['./vehicle-list-full.component.less'],
    encapsulation: ViewEncapsulation.None

})
export class VehicleListFullComponent implements OnInit, OnDestroy {


    // pola
    static filedLenghts = {
        '13': 50,
        '2': 80,
        '11': 200,
        '12': 100,
        '1': 350,
        '4': 200,
        '19': 80,
        '14': 80,
        '15': 80,
        '8': 80,
        '7': 95,
        '17': 180,
        '3': 185,
        '16': 100,
        '5': 100,
        '6': 80,
        '9': 100,
        '10': 100,
        '18': 100
    };

    // pola
    static fileds = {
        'a13': '13',
        'a2': '2',
        'a11': '11',
        'a12': '12',
        'a1': '1',
        'a4': '4',
        'a19': '19',
        'a14': '14',
        'a15': '15',
        'a8': '8',
        'a7': '7',
        'a17': '17',
        'a3': '3',
        'a16': '16',
        'a5': '5',
        'a6': '6',
        'a9': '9',
        'a10': '10',
        'a18': '18'
    };

    @Output()
    public get indicatorColumnTitle() {
        if (this.additionalParams.BinaryParamName) {
            return this.additionalParams.BinaryParamName;
        } else {
            return this.translateHelperService.firstLetterToUppercase(this.translateHelperService.sensor);
        }
    }

    public panelHeight = 320;

    public areaHeight = 320 - 60;

    public isIndictorColumnFullOn = false;
    public indictorColumnFullLength = 0;
    public indictorColumnFullCount = 0;
    public indictorColumnFullLeft = 100;

    @ViewChild('vehicleTable', { read: ElementRef })
    public vehicleTable?: ElementRef;

    public vehicleTableWidth?: number;

    public minWidth = 0;

    public additionalParams = {
        BinaryParamName: null,
        BinaryParamState: "all"
    };

    public isScrolling = false;

    /**
     * Flag indicating whether this component is visible
     */
    public isVisible = false;


    /**
     * konfiguracja
     */
    public config?: Config;

    /**
     * czy konfiguracja pokazana
     */
    public isConfigVisible = false;

    /**
     * List of vehicles to show
     */
    public vehicles?: Vehicle[];

    /**
     * Id of selected vehicle
     */
    public selectedVehicleId?: number;

    /**
     * Subscription to url changes stream
     */
    private navSub: Subscription;

    /**
     * Subscription to stream of vehicles to show
     */
    private vehiclesSub?: Subscription;


    /**
     * Subscription for changes from resize event listener
     */
    private resizeSub?: Subscription;


    private vehicleChangeSub?: Subscription;

    currentFilter: any;
    private firstRefresh: boolean;

    /**
     * transformer
     */
    private $fullAddressPipe = new FullAddressPipe();

    private $driverFullNamePipe = new DriverFullNamePipe();

    /**
     * kierunek sortowania
     */
    private sortBy = {
        Type: 11,
        Dir: 'ASC'
    };

    private isResizingTimeout: any;

    /**
     * opcje dla rekordow
     */
    public options: any = {
        tachoValue: [],
        indicatorStatus: null,
        indicatorValue: null
    };

    temperatureUnit: string  | null = '';

    constructor(
        private $nav: PanelNavigationService,
        private $router: Router,
        private $vehicle: VehicleService,
        private $configService: ConfigurationService,
        private $mapControlService: MapControlService,
        private $zone: NgZone,
        private $map: MapService,
        private $mapConfig: MapConfigService,
        private translateHelperService: TranslateHelperService,
        private translateService: TranslateService
    ) {
      this.translateService.get('labels.temperature-unit').subscribe(t => this.temperatureUnit = t);

        // Subscribe to stream of url changes
        this.navSub = this.$nav.getVisibilitySubject()
            .pipe(filter(item => (
                !item.subsites
                || item.subsites.indexOf('vehicle-full') !== -1
            )))
            .subscribe(change => {
                if (change.id) {
                    this.selectedVehicleId = parseInt(change.id, 10);
                } else {
                    this.selectedVehicleId = undefined;
                }
                this.isVisible = change.show;
                this.$vehicle.refreshListFiltered();
            });
        this.firstRefresh = true;
    }

    /**
     * Ng on init lifecycle hook
     */
    public ngOnInit(): void {

        // Build stream of vehicles to show from filtered vehicles and scroll event streams
        this.vehiclesSub =
            this.$vehicle.getListFiltered$()
                .subscribe(receivedVehicles => {
                    if (this.isVisible === true) {
                        this.$zone.run(() => {

                            const isTheSame = this.isTheSame(this.vehicles || [], receivedVehicles || []);
                            if (!isTheSame) {
                                this.$map.fitMapBoundsToVehicles(receivedVehicles);
                            }

                            // posortowanie
                            this.vehicles = this.sortByColumn(receivedVehicles);
                            if (this.isThisFirstRefresh(receivedVehicles)) {
                                this.vehicles = undefined;
                                this.firstRefresh = false;
                            }
                            else {
                                this.vehicles = this.sortByColumn(receivedVehicles);
                            }
                        });
                    }
                });

        // pobranie konfiguracji
        this.$configService.getConfig().subscribe(config => {
            this.config = config;
            this.updateTableWidth();
        });

        // resize
        this.resizeSub = this.$mapControlService.getResizeSubject().subscribe(result => {
            if (this.isResizingTimeout) {
                clearTimeout(this.isResizingTimeout);
            }
            const height = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;

            const eventHeight = result;

            let panelHeight = (height - eventHeight);
            if (panelHeight < 30) {
                panelHeight = 30;
            }

            if (eventHeight <= 0) {
                panelHeight = height;
            }

            this.panelHeight = panelHeight;


            this.isResizingTimeout = setTimeout(() => {
                this.areaHeight = panelHeight - 60;
            }, 300);

        });
    }

    /**
     * check if the same
     */
    private isTheSame(prev: Vehicle[], next: Vehicle[]): boolean {

        prev.sort((x, y) => x.Id! - y.Id!);
        next.sort((x, y) => x.Id! - y.Id!);

        let i = 0;
        let j = 0;
        const joined: Vehicle[] = [];

        while (i < prev.length && j < next.length) {

            if (prev[i].Id === next[j].Id) {
                joined.push(prev[i]);
                i += 1;
                j += 1;
            } else if (prev[i].Id! < next[j].Id!) {
                i += 1;
            } else {
                j += 1;
            }

        }

        const flag = (joined.length === prev.length) && (prev.length === next.length);


        return flag;
    }

    /**
     * Ng on destroy lifecycle hook
     */
    public ngOnDestroy(): void {

        if (this.navSub) {
            this.navSub.unsubscribe();
        }
        if (this.vehiclesSub) {
            this.vehiclesSub.unsubscribe();
        }
        if (this.resizeSub) {
            this.resizeSub.unsubscribe();
        }
        if (this.vehicleChangeSub) {
            this.vehicleChangeSub.unsubscribe();
        }
    }


    /**
     * Handles if user selects a vehicle
     * @param vehicle selected vehicle
     */
    public onSelect(vehicle: Vehicle): void {


        // odznaczenie i zaznaczenia
        if (vehicle.Id && this.selectedVehicleId === vehicle.Id) {
            this.selectedVehicleId = undefined;
            this.$mapConfig.setCurrentVehicleId('tk-list-full', undefined);
            this.$router.navigate(['panel', 'vehicle'], { queryParams: { 'mode': 'full' } });
            this.$map.centerMap();
        } else {
            this.selectedVehicleId = vehicle.Id;
            this.$mapConfig.setCurrentVehicleId('tk-list-full', this.selectedVehicleId);
            this.$router.navigate(['panel', 'vehicle'], { queryParams: { 'mode': 'full', 'id': this.selectedVehicleId } });
        }

    }



    /**
     * konfiguracja table
     */
    public configureTable() {
        this.isConfigVisible = true;
    }

    public switchToVehicleListLite() {
        if (this.selectedVehicleId && this.selectedVehicleId > 0) {
            this.$router.navigate(['panel', 'vehicle'], { queryParams: { 'mode': 'details', 'id': this.selectedVehicleId } });
        } else {
            this.$router.navigate(['panel', 'vehicle'], { queryParams: { 'mode': 'lite' } });
        }
    }

    /**
     * wykonanie zmiany
     */
    public onConfigureTableClose(data: any) {
        this.isConfigVisible = false;
        this.$configService.getConfig().subscribe(config => {
            this.config = config;
            this.updateTableWidth();
        });
    }

    /**
     * pokazanie kolumy
     * @param type kolumna
     */
    public showColumn(type: number): boolean {
        if (this.config && this.config.VehicleFullListColumns.indexOf(type) !== -1) {
            return true;
        }
        return false;
    }

    /**
     * sortowanie kolumn
     */
    public setSortColumn(type: number): void {
        let dir = '';
        if (this.sortBy && this.sortBy.Type === type && this.sortBy.Dir) {
            dir = this.sortBy.Dir;
        }
        // zmiana bo kliknieto
        switch (dir) {
            case 'ASC':
                dir = 'DESC';
                break;
            case 'DESC':
                dir = '';
                break;
            default:
                dir = 'ASC';
                break;
        }

        // zapisanie nowego sortowania
        this.sortBy = {
            Type: type,
            Dir: dir
        };


        // sortowanie
        this.$zone.run(() => {
            this.vehicles = this.sortByColumn(this.vehicles!);
        });
    }
    /**
     * pobranie kierunku sortowania
     * @param type typ kolumy
     */
    public getSortColumnDir(type: number, dataType?: string): string {
        if (this.sortBy && this.sortBy.Type === type && this.sortBy.Dir) {
            let sort = this.sortBy.Dir === 'ASC' ? 'A-Z' : 'Z-A';

            switch (dataType) {
                case 'min-max':
                    sort = sort === 'A-Z' ? 'min-max' : 'max-min';
                    break;
                case 'number':
                    sort = sort === 'A-Z' ? '0-9' : '9-0';
                    break;
            }

            return sort;
        }
        return '';
    }

    /**
     * posortowanie
     */
    private sortByColumn(vehicles: Vehicle[]): Vehicle[] {
        const sortedVehicles = vehicles.sort((a, b) => {

            let result = 0;

            if (this.sortBy) {
                const dir = this.sortBy.Dir;

                if (!dir || dir === '') {
                    return result;
                }

                const controlIndicatorsA = a.ControlIndicators;
                const controlIndicatorsB = b.ControlIndicators;

                switch (this.sortBy.Type) {
                    // Adres ostatniej znanej pozycji
                    case 1:
                        const displayedAddressA = this.$fullAddressPipe.transform(a.LL!);
                        const displayedAddressB = this.$fullAddressPipe.transform(b.LL!);
                        result = this.compareStrings(displayedAddressA, displayedAddressB);
                        break;
                    // Czas od ostatniej zmiany statusu
                    case 2:
                        //Przypisujemy odwrotność, ponieważ najdawniejszy czas zmiany statusu ma najniższą wartość - a chcemy umieścić go na końcu.
                        //Tak samo najnowszy czas zmiany statusu (np. sprzed kilku sekund) będzie miał najwyższą wartość, ale chcemy umieścić go na początku.
                        //Generalnie ponieważ nie wyświetlamy daty zmiany statusu a raczej wynik operacji
                        //[aktualny czas] - [czas zmiany], konieczne jest odwrócenie wyniku.
                        result = -this.compareControlIndicatorGroupTime(controlIndicatorsA!, controlIndicatorsB!, 13);
                        break;
                    // Kierowca
                    case 4:
                        const displayedDriverA = this.$driverFullNamePipe.transform(a.LastDriver!);
                        const displayedDriverB = this.$driverFullNamePipe.transform(b.LastDriver!);
                        result = this.compareStrings(displayedDriverA, displayedDriverB);
                        break;
                    // Nazwa pojazdu
                    case 11:
                        result = this.compareStrings(a.Nm!, b.Nm!);
                        break;
                    // Status
                    case 13:
                        result = (a.St || 0) - (b.St || 0);
                        break;
                    case 5: // Licznik km
                    case 6: // Napięcie
                    case 7: // Obroty
                    case 8: // Paliwo
                    case 9: // Paliwo CAN
                    case 10: // Pedał gazu
                    case 12: // Prędkość
                    case 14: // GPS
                    case 15: // GSM
                    case 17: // Temperatura
                    case 18: // Zużycie CAN
                    case 19:
                        result = this.compareControlIndicatorGroupValue(controlIndicatorsA!, controlIndicatorsB!, this.sortBy.Type)
                        break;
                }

                // odwrócenie wyniku jeśli sortujemy malejąco
                if (dir === 'DESC') {
                    result = -result;
                }
            }

            return result;
        });

        return JSON.parse(JSON.stringify(sortedVehicles));
    }

    private compareControlIndicatorGroupValue(a: VehicleControlIndicator[], b: VehicleControlIndicator[], group: number): number {
        const controlIndicatorA = (a || []).find(o => o && o.Group === group);
        const controlIndicatorB = (b || []).find(o => o && o.Group === group);

        const valueA = this.getLastControlIndicatorValueOrDefault(controlIndicatorA!);
        const valueB = this.getLastControlIndicatorValueOrDefault(controlIndicatorB!);

        return valueA - valueB;
    }

    private getLastControlIndicatorValueOrDefault(indicator: VehicleControlIndicator): any {
        if (indicator && indicator.LV && (indicator.LV.V || indicator.LV.V === 0)) {
            return indicator.LV.V;
        }
        else {
            return -1000000000;
        }
    }

    private compareStrings(a: string, b: string): number {
        const valueA = (a || '').toLowerCase();
        const valueB = (b || '').toLowerCase();

        return valueA > valueB ? 1 : (valueA < valueB ? -1 : 0);
    }

    private compareControlIndicatorGroupTime(a: VehicleControlIndicator[], b: VehicleControlIndicator[], group: number): number {
        const controlIndicatorA = (a || []).find(o => o && o.Group === group);
        const controlIndicatorB = (b || []).find(o => o && o.Group === group);

        const valueA = this.getLastControlIndicatorTimeInMilliseconds(controlIndicatorA!);
        const valueB = this.getLastControlIndicatorTimeInMilliseconds(controlIndicatorB!);

        return valueA - valueB;
    }

    private getLastControlIndicatorTimeInMilliseconds(indicator: VehicleControlIndicator): number {
        if (indicator && indicator.LV && indicator.LV.T) {
            return new Date(indicator.LV.T).getTime();
        }
        else {
            return 0;
        }
    }

    /**
     * zmiana filtrowania statusu czujniak
     * @param status status
     */
    public onIndicatorStatusFilterChanged(status: any) {
        // const options = JSON.parse(JSON.stringify(this.options || {}));
        // options.indicatorStatus = status;
        // this.options = options;
        this.additionalParams.BinaryParamState = status;
        this.additionalParams = JSON.parse(JSON.stringify(this.additionalParams));
    }

    /**
    * zmiana filtrowania wartosci czujnika
    * @param status status
    */
    public onIndicatorValueFilterChanged(value: any) {
        this.additionalParams.BinaryParamName = value;
        this.additionalParams = JSON.parse(JSON.stringify(this.additionalParams));
    }

    /**
     * zmiana zakresu tacho
     */
    public onTachoValueFilterChanged(value: any) {
        const options = JSON.parse(JSON.stringify(this.options || {}));
        options.tachoValue = value;
        this.options = options;
        this.updateTableWidth();
    }

    /**
     * pokazywanie kolumn tacho
     */
    public showTachoColumn(val?: string): boolean {
        if (!this.options || !this.options.tachoValue) {
            return true;
        }
        if (!val) {
            return this.options.tachoValue.length === 0;
        }
        return this.options.tachoValue.indexOf(val) !== -1;
    }

    /**
     * aktualizacja rozmaru tabel
     */
    private updateTableWidth() {

        const keys = Object.keys(VehicleListFullComponent.filedLenghts);
        this.minWidth = 0;
        for (const k of keys) {
            if (this.config && this.config.VehicleFullListColumns.indexOf(parseInt(k, 10)) !== -1) {
                this.minWidth += (VehicleListFullComponent.filedLenghts as any)[k];
                this.minWidth += 3;
            }
        }

        // zbadanie tacho
        if (this.options.tachoValue.indexOf('driving') !== -1) {
            this.minWidth += VehicleListFullComponent.filedLenghts['16'];
            this.minWidth += 3;
        }
        if (this.options.tachoValue.indexOf('resting') !== -1) {
            this.minWidth += VehicleListFullComponent.filedLenghts['16'];
            this.minWidth += 3;
        }
        if (this.options.tachoValue.indexOf('free') !== -1) {
            this.minWidth += VehicleListFullComponent.filedLenghts['16'];
            this.minWidth += 3;
        }
        if (this.options.tachoValue.indexOf('working') !== -1) {
            this.minWidth += VehicleListFullComponent.filedLenghts['16'];
            this.minWidth += 3;
        }

        if (this.options.tachoValue.length > 0) {
            this.minWidth -= VehicleListFullComponent.filedLenghts['16'];
            this.minWidth += 3;
        }

        // this.minWidth += 50;
        // this.vehicleTableWidth = this.vehicleTable.nativeElement.clientWidth;
        this.updateInidicatorFieldPosition();
    }


    public onIndictorColumnFullChange(flag: boolean) {
        this.isIndictorColumnFullOn = flag;
        this.updateInidicatorFieldPosition();
    }

    private updateInidicatorFieldPosition() {
        if (this.isIndictorColumnFullOn === true) {
            // klucz to 3
            let fields = {};

            if (this.config?.VehicleFullListColumnsOrder) {
                for (const key of this.config.VehicleFullListColumnsOrder) {
                    (fields as any)['a' + key] = key;
                }
            } else {
                fields = VehicleListFullComponent.fileds;
            }
            const keys = Object.keys(fields);
            this.indictorColumnFullLeft = 0;
            for (const key of keys) {
                const k = parseInt((VehicleListFullComponent.fileds as any)[key], 10);
                if (this.config && this.config.VehicleFullListColumns.indexOf(k) !== -1) {
                    if (key === 'a3') {
                        break;
                    }
                    this.indictorColumnFullLeft += (VehicleListFullComponent.filedLenghts as any)[k];
                    this.indictorColumnFullLeft += 2;
                }
            }
            this.indictorColumnFullLength = this.indictorColumnFullCount * (24) + 40;
        } else {
            this.indictorColumnFullLength = VehicleListFullComponent.filedLenghts['3'];
        }

    }

    public onItemDataChange(items: any[]) {
        const l = items.length;
        this.indictorColumnFullCount = Math.max(l, this.indictorColumnFullCount);
    }

    onFilterChanged(filter: any) {
        if (filter) {
            if (this.isFilterEmpty(filter)) {
                this.currentFilter = null;
                return;
            }
        }

        this.currentFilter = filter;
    }

    private isThisFirstRefresh(vehicles: Vehicle[]): boolean {
        return this.firstRefresh && vehicles && vehicles.length == 0 && !this.currentFilter;
    }

    private isFilterEmpty(filter: any) {
        const isStatusNull = !filter.Status || filter.Status === 0;
        const isTagsNull = !filter.Tags || filter.Tags.length === 0;
        const isPhraseNull = !filter.Phrase;
        const isBinaryParamNull = !filter.BinaryParamName;
        const isBinaryStateNull = filter.BinaryParamState == undefined;

        return isStatusNull && isTagsNull && isPhraseNull && isBinaryParamNull && isBinaryStateNull;
    }

    onVehicleUpdate(event: any) {
        throw new Error("method 'onVehicleUpdate' not implemented");
    }

    onScroll(event: any) {
        throw new Error("method 'onScroll' not implemented");
    }
}
